import { makeAutoObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';
import type { UserEntry } from '../../users';
import { selectedRulesStore } from '../../bulk/stores/selectedRulesStore';

interface Project {
  name: string;
  id: number | string;
}

export const ALL_PROJECTS: Project = { id: 'all_projects', name: 'All projects' };

class SelectedProjectStore {
  selectedProject: Project | null = null;

  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: 'SelectedProjectStore',
      properties: ['selectedProject'],
      storage: window.localStorage,
    });
  }

  init(user: UserEntry) {
    if (!this.selectedProject) {
      user.role === 'user' ? this.changeProject(user.projects[0]) : this.changeProject(ALL_PROJECTS);
    }
  }

  changeProject(prj: Project) {
    this.selectedProject = prj;
    selectedRulesStore.reset();
  }

  get isAllProjectsSelected() {
    return this.selectedProject?.id === ALL_PROJECTS.id;
  }
}

export const selectedProjectStore = new SelectedProjectStore();
